<div class="container ">
  <!-- Top Buttons -->
  <div class="mb-3 d-flex gap-2 justify-content-start">
    <button class="btn btn-primary">Button 1</button>
    <button class="btn btn-secondary">Button 2</button>
    <button class="btn btn-success">Button 3</button>
  </div>

  <!-- Column Layout -->
    <div class=" mb-3 d-flex flex-wrap row-cols-3">
        <div class="p-2" class="col-3" >
        <div class="border p-2">Column 1 (20%)</div>
        </div>
        <div class="p-2" class="col-4" style="width: 40%;">
        <div class="border p-2">Column 2 (40%)</div>
        </div>
        <div class="p-2" class="col-5" style="width: 40%;">
        <div class="border p-2">Column 3 (40%)</div>
        </div>
    </div>
  
</div>
